import { VNode, VNodeChildren, h } from 'vue';
import { useCurrentRoute } from '@/ui/routes';
import { inputField } from '@/ui/components/form';

export const col = (contents: VNodeChildren, narrow = false, classes = {}) => h(
  'div',
  {
    class: {
      column: true,
      'is-narrow': narrow,
      ...classes,
    },
  },
  contents,
);

/**
 * Wrapper for columns
 */
export const cols = (columns: VNode[], classes = '') => h(
  'div',
  { class: `columns ${classes}` },
  columns,
);

export const filterColumn = (contents: VNodeChildren) => h(
  'div',
  {
    class: 'column is-narrow is-relative is-unselectable',
    style: 'width: 280px; padding-top:43px;',
  },
  contents,
);

/**
 * @deprecated use horizontal/FilterForm.vue instead
 */
export const filterFormHorizontal = (contents: VNodeChildren, classes = '') => {
  const currentRoute = useCurrentRoute();
  const tab = currentRoute.value?.query?.tab as string|undefined;

  return h(
    'form',
    {
      class: `flex relative filters-form ${classes}`,
    },
    [
      contents,
      tab ? inputField({
        label: '',
        placeholder: '',
        required: false,
        disabled: false,
        value: tab,
        name: 'tab',
        type: 'hidden',
      }, () => {}) : null,
    ],
  );
};

export const indexViewVertical = (filters: VNodeChildren, box: VNodeChildren) => cols([
  filterColumn(filters),
  col(box),
]);

//horizontal
export const indexView = (filters: VNodeChildren, box: VNodeChildren) => h('div', [
  filters,
  cols([col(box)]),
]);
